import React, { useContext, useRef, useState } from 'react';
import { GMCContext } from '../../GMCContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';


export default function IconControl() {
  const {
    dbuser,
    toastSuccess,
    toastError,
    getuserDB,
  } = useContext(GMCContext);

  const [tabName, setTabName] = useState(''); // Tab name input state
  const [error, setError] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([null, null]); // Track two files (logo and favicon)
  const [previewUrls, setPreviewUrls] = useState([null, null]); // Track two preview URLs (logo and favicon)

  const fileInputRef1 = useRef(null); // Ref for logo file input
  const fileInputRef2 = useRef(null); // Ref for favicon file input
  const navigate = useNavigate();


  const handleDragOver = (event) => {
    event.preventDefault();
  };


  const validateFile = (file) => {
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    const maxSize = 2 * 1024 * 1024; // 2MB

    if (!allowedTypes.includes(file.type)) {
      setError('Only PNG, JPEG, and JPG files are allowed.');
      return false;
    }

    if (file.size > maxSize) {
      setError('File size should be less than 2MB.');
      return false;
    }

    setError('');
    return true;
  };


  const handleDrop = (event, index) => {

    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file && validateFile(file)) {
      const newSelectedFiles = [...selectedFiles];
      newSelectedFiles[index] = file;
      setSelectedFiles(newSelectedFiles);

      const newPreviewUrls = [...previewUrls];
      newPreviewUrls[index] = URL.createObjectURL(file);
      setPreviewUrls(newPreviewUrls);
    }
  };


  const handleFileChange = (event, index) => {

    const file = event.target.files[0];
    if (file && validateFile(file)) {
      const newSelectedFiles = [...selectedFiles];
      newSelectedFiles[index] = file;
      setSelectedFiles(newSelectedFiles);

      const newPreviewUrls = [...previewUrls];
      newPreviewUrls[index] = URL.createObjectURL(file);
      setPreviewUrls(newPreviewUrls);
    }
  };


  const handleClick = (index) => {

    if (index === 0) {
      fileInputRef1.current?.click();
    } else {
      fileInputRef2.current?.click();
    }
  };


  const updateLogoAndFavicon = async () => {

    try {
      const formData = new FormData();
      formData.append('method', 'user');
      formData.append('submethod', 'update_logo_favicon');
      formData.append('key', process.env.REACT_APP_KEY);
      formData.append('user_id', dbuser.user_id);
      formData.append('tab_name', tabName);

      // Append both selected files (logo and favicon) to the form data
      selectedFiles.forEach((file, index) => {
        if (file) {
          formData.append(`file${index + 1}`, file); // Append with keys file1 and file2
        }
      });

      const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.error) {
        toastError(response.data.error);
      } else {
        toastSuccess(response.data.data);
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Error making API call:', error?.response || error);
      toastError('Failed to submit update. Please check the console for more details.');
    }

    // getuserDB();
  };

  return (
    <>
      <Header />
      <Sidebar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8 col-xxl-6">
                <div className="card shadow">
                  <div className="card-header text-center">
                    <h4 className="card-title mb-0">Update Logo and Favicon</h4>
                  </div>
                  <div className="card-body p-4">
                    <h2 className="mb-4 text-center">Logo & Favicon Update</h2>
                    <div className="row gy-4">
                      <div className="col-md-6">
                        <div
                          onClick={() => handleClick(0)}
                          onDragOver={handleDragOver}
                          onDrop={(e) => handleDrop(e, 0)}
                          className="border rounded p-3 text-center"
                          style={{ cursor: 'pointer' }}
                        >
                          {previewUrls[0] ? (
                            <img src={previewUrls[0]} alt="Logo Preview" className="img-fluid" />
                          ) : (
                            <p>Click or drag logo image here</p>
                          )}
                        </div>
                        <input
                          type="file"
                          ref={fileInputRef1}
                          style={{ display: 'none' }}
                          onChange={(e) => handleFileChange(e, 0)}
                        />
                      </div>
                      <div className="col-md-6">
                        <div
                          onClick={() => handleClick(1)}
                          onDragOver={handleDragOver}
                          onDrop={(e) => handleDrop(e, 1)}
                          className="border rounded p-3 text-center"
                          style={{ cursor: 'pointer' }}
                        >
                          {previewUrls[1] ? (
                            <img src={previewUrls[1]} alt="Favicon Preview" className="img-fluid" />
                          ) : (
                            <p>Click or drag favicon image here</p>
                          )}
                        </div>
                        <input
                          type="file"
                          ref={fileInputRef2}
                          style={{ display: 'none' }}
                          onChange={(e) => handleFileChange(e, 1)}
                        />
                      </div>
                    </div>
                    {error && <p className="text-danger mt-3">{error}</p>}
                    <div className="mt-4">
                      <input
                        type="text"
                        className="form-control mb-3"
                        placeholder="Change Tab Name"
                        value={tabName}
                        onChange={(e) => setTabName(e.target.value)}
                      />
                      <button
                        className="btn btn-primary w-100"
                        onClick={updateLogoAndFavicon}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
